import moment from 'moment';

const archivedAt = (record) => (record.archive_detail && record.archive_detail.archived_at) || null;

export const ArchivedWebpageColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70,
    sorter: (a, b) => a.index - b.index
  },
  {
    title: 'Webpage Name',
    dataIndex: 'config_name',
    width: 180,
    sorter: (a, b) => (a.config_name || '').localeCompare(b.config_name || '')
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url_name',
    width: 180,
    slot: 'urls'
  },
  {
    title: 'Tags',
    dataIndex: 'tags',
    width: 150,
    slot: 'tags'
  },
  {
    title: 'Previous Plan',
    dataIndex: 'prev_plan_type',
    width: 120,
    slot: 'prev_plan',
    sorter: (a, b) => {
      const aPlan = (a.archive_detail && a.archive_detail.prev_plan_type) || '';
      const bPlan = (b.archive_detail && b.archive_detail.prev_plan_type) || '';
      return aPlan.localeCompare(bPlan);
    }
  },
  {
    title: 'Remark',
    dataIndex: 'remark',
    width: 180,
    slot: 'remark'
  },
  {
    title: 'Archived On',
    dataIndex: 'archived_on',
    width: 140,
    slot: 'archived_on',
    sorter: (a, b) => moment(archivedAt(a)).diff(moment(archivedAt(b)))
  },
  {
    title: 'Time Since Archive',
    dataIndex: 'time_since_archive',
    width: 160,
    slot: 'time_since_archive',
    sorter: (a, b) => moment(archivedAt(a)).diff(moment(archivedAt(b)))
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];
